
import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import EquipoGrid from "../../components/Nosotros/EquipoGrid/EquipoGrid";

import "./Nosotros.css"
import NoticiasDestacadas from "../../components/Nosotros/NoticiasDestacadas/NoticiasDestacadas";

function Nosotros() {
    return (
        <>
            <Navbar/>

        <main className="nosotros-page">

            <EquipoGrid />

            <NoticiasDestacadas />
        </main>
            <Footer />

            </>
    );
}

export default Nosotros;
